import { defineMessages } from "react-intl";

export default defineMessages({
    softwareBoardTitle: {
        id: "software-onboarding-v2.common.utils.get-template-static-content.software-board-title",
        defaultMessage: "Jira Software",
        description:
            "Jira software board title for template choice page while onboarding"
    },
    businessBoardTitle: {
        id: "software-onboarding-v2.common.utils.get-template-static-content.business-board-title",
        defaultMessage: "Jira Work Management",
        description:
            "Jira work management board title for template choice page while onboarding"
    },
    kanbanCardName: {
        id: "software-onboarding-v2.common.utils.get-template-static-content.kanban-card-name",
        defaultMessage: "Kanban",
        description:
            "Kanban card name of Template choice screen during Jira onboarding"
    },
    kanbanCardSummary: {
        id: "software-onboarding-v2.common.utils.get-template-static-content.kanban-card-summary",
        defaultMessage: "A simple board to visualize your workflow",
        description:
            "Kanban card summary of Template choice screen during Jira onboarding"
    },
    kanbanCardDescriptionText: {
        id: "software-onboarding-v2.common.utils.get-template-static-content.kanban-card-description-text",
        defaultMessage:
            "A flexible and efficient way to manage agile work, with a board and timeline.",
        description:
            "Kanban card description of Template choice screen during Jira onboarding"
    },
    scrumCardName: {
        id: "software-onboarding-v2.common.utils.get-template-static-content.scrum-card-name",
        defaultMessage: "Scrum",
        description:
            "Scrum card name of Template choice screen during Jira onboarding"
    },
    scrumCardSummary: {
        id: "software-onboarding-v2.common.utils.get-template-static-content.scrum-card-summary",
        defaultMessage: "Deliver work in short, repeatable time blocks",
        description:
            "Scrum card summary of Template choice screen during Jira onboarding"
    },
    scrumCardDescriptionText: {
        id: "software-onboarding-v2.common.utils.get-template-static-content.scrum-card-description-text",
        defaultMessage:
            "Plan, prioritize, and schedule work using agile sprints with a backlog, board and timeline.",
        description:
            "Scrum card description of Template choice screen during Jira onboarding"
    },
    businessCardName: {
        id: "software-onboarding-v2.common.utils.get-template-static-content.business-card-name",
        defaultMessage: "Business",
        description:
            "Business card name of Template choice screen during Jira onboarding"
    },
    businessCardSummary: {
        id: "software-onboarding-v2.common.utils.get-template-static-content.business-card-summary",
        defaultMessage: "Collaboration for business teams",
        description:
            "Business card summary of Template choice screen during Jira onboarding"
    },
    businessCardDescription: {
        id: "software-onboarding-v2.common.utils.get-template-static-content.business-card-description",
        defaultMessage:
            "Designed to help your business team collaborate and connect, with list and calendar views, forms, and more.",
        description:
            "Business card description of Template choice screen during Jira onboarding"
    },
    statusPopular: {
        id: "software-onboarding-v2.common.utils.get-template-static-content.status-popular",
        defaultMessage: "Popular",
        description:
            "Label shown to indicate a Template Choice card is popular during onboarding"
    }
});
